import { GET_COIN_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_COIN_RECIPES_SUCCESS: {
      const coinRecipes = action.payload;

      if (!coinRecipes){
        return {...state};
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
